import { useParams } from "@solidjs/router";
import { Component, ParentComponent } from "solid-js";

import { UserRoleType } from "../../schema/graphql.js";
import { useAuth } from "../auth/AuthContext.js";
import { AgencySelector } from "../common/AgencySelector.js";
import { Layout } from "../common/Layout.js";
import { PageHeader } from "../common/PageHeader.js";
import { ShowForRoles } from "../common/ShowForRoles.js";
import { useAgencySettings } from "./AgencySettingsContext.js";
import { AgencySmsQuestionnaireExportToken } from "./AgencySmsQuestionnaireExportToken.js";
import SmsForm from "./SmsForm.js";

const SmsQuestionnaireContainer: Component = () => {
  const auth = useAuth();
  const agencyId = Number.parseInt(
    useParams().id?.toString() ??
      auth?.authenticatedUser()?.agencyId?.toString(),
    10,
  );

  const agencySettings = useAgencySettings();

  agencySettings?.setHeaderContentRight(
    <ShowForRoles roles={[UserRoleType.Admin]}>
      <div class="flex flex-wrap items-center gap-2">
        <AgencySmsQuestionnaireExportToken agencyId={agencyId} />
      </div>
    </ShowForRoles>,
  );
  return (
    <section>
      <div class="mb-4 space-y-2 text-sm">
        <p>
          If you don't already have a sponsorship licence, please fill out the
          form below so that we can assist you in your application.
        </p>
        <p>
          Please note: when inserting postcodes, be sure to include spaces, eg.,
          SW1 1AA
        </p>
      </div>{" "}
      <SmsForm agencyId={agencyId} />
    </section>
  );
};

export const SmsQuestionnaireContainerWrapper: ParentComponent = (props) => {
  return (
    <Layout>
      <PageHeader parentTitle="Admin" title="Sms Questionnaire" class="mb-4">
        <AgencySelector label="" />
      </PageHeader>
      {props.children}
    </Layout>
  );
};

export default SmsQuestionnaireContainer;
